module.exports = __webpack_public_path__ + "media/widget/non_drug_allergies-2c15cc30.png";